import { useWizard } from "react-use-wizard";
import sellSteps from "../../sellSteps";
import {
  TKeyOfDataWizardSell,
  TStringKeysOfIFillDataWizardSell,
} from "../../..";
import { EReadinessForLowerSellPrice } from "../../../../../../../shared/wizard/steps/types";
import OffersForClientStep from "../../../../../../../shared/wizard/steps/offerForRieltorFromClientStep";

interface IDoNotKnowPriceSellStep_5 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardSell) => void;
  data: EReadinessForLowerSellPrice | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const DoNotKnowPriceSellStep_5 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IDoNotKnowPriceSellStep_5) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.sell.step_4);
    onReset(["offersForClient"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.doNotKnowPrice.sell.step_6);
  };

  return (
    <div>
      <OffersForClientStep
        onChange={onChange}
        onPrevStep={handlePrevStep}
        onNexStep={handleNexStep}
        data={data}
        isNextStepDisabled={isNextStepDisabled}
      />
    </div>
  );
};

export default DoNotKnowPriceSellStep_5;
